module.exports = __webpack_public_path__ + "static/media/hero-artist-in-grand-hall.47824be0.jpeg";